import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonRounded, StickyFooter } from 'is24-corecss'
import PublicationBarLoader from '../../../../common/display/publicationBarLoader/PublicationBarLoader'
import styles from './PublicationStickyFooter.module.css'

export interface PublicationStickyFooterProps {
  isSaving: boolean
  isNativeMobileView: boolean
  onPreview: () => void
  onSave: () => void
  onSaveForLater: () => Promise<boolean>
  increaseSubmitCount: () => void
  isWaitingListFlow?: boolean
}

export const PublicationStickyFooter = ({
  isSaving,
  isNativeMobileView,
  onPreview,
  onSave,
  onSaveForLater,
  increaseSubmitCount,
  isWaitingListFlow,
}: PublicationStickyFooterProps) => {
  const { t } = useTranslation()

  if (isSaving) {
    return <PublicationBarLoader />
  }
  if (isWaitingListFlow) {
    const webviewPrimaryButton = (
      <div className='align-center'>
        <ButtonRounded
          id='checkout-listing-type'
          variant='filledDefault'
          label={t('button.save.waitingList')}
          // mf is for mouseflow
          className='mf-form-button'
          onClick={() => {
            increaseSubmitCount()
            onSave()
          }}
          disabled={isSaving}
        />
      </div>
    )
    return (
      <StickyFooter
        align='center'
        infoContent=''
        primaryButton={webviewPrimaryButton}
        className={`${styles.webviewStickyFooter}`}
        show
      />
    )
  }

  if (isNativeMobileView) {
    const webviewPrimaryButton = (
      <div className='one-half'>
        <ButtonRounded
          id='checkout-listing-type'
          variant='filledDefault'
          label={t('button.save.short')}
          // mf is for mouseflow
          className='mf-form-button one-whole'
          onClick={() => {
            // TODO HPEP-1348 tracking
            increaseSubmitCount()
            onSave()
          }}
          disabled={isSaving}
        />
      </div>
    )

    const webviewSecondaryButton = (
      <div className='one-half'>
        <ButtonRounded
          variant='textDefault'
          label={t('button.save.saveForLater')}
          className='one-whole'
          onClick={async () => {
            increaseSubmitCount()
            const success = await onSaveForLater()
            if (success) {
              window.location.href = 'is24://retargetShowOffer'
            }
          }}
          disabled={isSaving}
        />
      </div>
    )

    return (
      <StickyFooter
        align='center'
        infoContent=''
        primaryButton={webviewPrimaryButton}
        secondaryButton={webviewSecondaryButton}
        className={styles.webviewStickyFooter}
        show
      />
    )
  }

  const primaryButton = (
    <ButtonRounded
      id='checkout-listing-type'
      data-cy='checkout-listing-type'
      className='mf-form-button'
      variant='filledDefault'
      label={t('button.save.default', 'Publish')}
      onClick={() => {
        increaseSubmitCount()
        onSave()
      }}
      disabled={isSaving}
    />
  )

  const secondaryButton = (
    <ButtonRounded
      id='preview-listing-type'
      variant='outlineStrong'
      label={t('button.preview', 'Preview')}
      onClick={() => {
        increaseSubmitCount()
        onPreview()
      }}
      disabled={isSaving}
    />
  )

  return (
    <StickyFooter align='center' infoContent='' primaryButton={primaryButton} secondaryButton={secondaryButton} show />
  )
}
